import React from 'react';
import clsx from 'clsx';
import {
  DISCOUNT_ACTIVE_STATUS_COLOR,
  DISCOUNT_INACTIVE_STATUS_COLOR,
} from '../../resources/constants';

interface IDiscountStatusProps {
  status: string | null | boolean;
  classes?: string;
}

const DiscountStatus: React.FC<IDiscountStatusProps> = ({
  status,
  classes
}) => {
  const statusClass = clsx(
    'w-[30px] h-[30px] rounded rounded-full flex items-center justify-center text-sm',
    {
      [DISCOUNT_INACTIVE_STATUS_COLOR]: status === false,
      [DISCOUNT_ACTIVE_STATUS_COLOR]: status === true
    },
    classes
  );

  const displayStatus = status !== null ? status : '-';

  return (
    <div className="w-full flex">
      <div className={statusClass}>{displayStatus}</div>
    </div>
  );
};

export default DiscountStatus;
